import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';

export const BASE_URL = '/offset-service/submissions';
export const NOT_AUTH_OFFICIAL_SEARCH_SUBMISSION = 'searchSubmissions';
export const NOT_AUTH_OFFICIAL_GET_NEW_SUBMISSION_ID = 'getNewSubmissionsId';
export const NOT_AUTH_OFFICIAL_GET_BY_ID = 'notReplaceMao/getById';
export const NOT_AUTH_OFFICIAL_SAVE = 'save';

@Injectable({ providedIn: 'root' })
export class NotAuthorizedOfficialService {
  constructor(private http: HttpClient) {}

  searchSubmissions(body): Observable<any> {
    return this.http.post<any>(`${environment.apiUrl}${BASE_URL}/${NOT_AUTH_OFFICIAL_SEARCH_SUBMISSION}`, body);
  }

  getNewSubmissionsId(payload: any): Observable<any> {
    return this.http.post<any>(`${environment.apiUrl}${BASE_URL}/${NOT_AUTH_OFFICIAL_GET_NEW_SUBMISSION_ID}`, payload);
  }

  getById(entityId: number): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}${BASE_URL}/${NOT_AUTH_OFFICIAL_GET_BY_ID}/${entityId}`);
  }

  save(payload): Observable<any> {
    return this.http.post<any>(`${environment.apiUrl}${BASE_URL}/${NOT_AUTH_OFFICIAL_SAVE}`, payload);
  }
}
